import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import {
  getCompanyLogo,
  getJobExperiences,
  getKeywords,
  getSalaryAmount,
} from "../../../../helpers/common";
import { useSelector } from "react-redux";
import AddToBookmarkJob from "../../../../helpers/Common/AddToBookmarkJob";
import ApplyJobModal from "../../../../helpers/Common/ApplyJobModal";
import userImage6 from "../../../../assets/images/avatar.png";
const BookmarkJobItem = ({ bookmarkItem }) => {
  const navigate = useNavigate();
  const [applyJobModal, setApplyJobModal] = useState(false);
  const [currJob, setCurrJob] = useState({});
  // Hides this card as soon as its bookmark is removed
  const [isRemoved, setIsRemoved] = useState(false);

  const openApplyJobModal = (jobDetails) => {
    setApplyJobModal(!applyJobModal);
    setCurrJob(jobDetails);
  };

  // Getting the company details
  const companyDetails = bookmarkItem?.company;

  // Getting the job details
  const jobDetails = bookmarkItem?.job;

  // Job detail page URL
  const jobDetailsUrl = `/job/details/${jobDetails?.id}/${jobDetails?.url}`;

  // Whole card click -> job details page.
  const handleCardClick = (e) => {
    if (e.target.closest("a, button, .favorite-icon, .btn, .badge")) {
      return;
    }
    navigate(jobDetailsUrl);
  };

  const candidateReducer = useSelector((state) => state.candidate);
  const appliedJobs = candidateReducer.jobApplications;

  const jobs = Array.isArray(appliedJobs)
    ? appliedJobs
    : appliedJobs?.data || [];

  // Find matching application to extract status and applied date
  const isAppliedJob = jobs.find((item) => item?.job?.id === jobDetails?.id);

  // Extract application date
  const rawAppliedDate =
    isAppliedJob?.createdAt || isAppliedJob?.appliedAt || isAppliedJob?.date;
  const formattedAppliedDate = rawAppliedDate
    ? new Date(rawAppliedDate).toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : null;

  // Resolve Job Status (Open/Closed/Active)
  
  const applicationStatus = isAppliedJob?.status?.toLowerCase();

  return (
    <>
      <div
        className="card border-0 shadow-sm rounded-3 mt-4 transition-all"
        onClick={handleCardClick}
        style={
          isRemoved
            ? { display: "none" }
            : { cursor: "pointer", transition: "transform 0.2s, box-shadow 0.2s" }
        }
      >
        <div className="card-body p-4 position-relative">
          {/* Bookmark Icon Positioned Top Right */}
          <div className="position-absolute top-0 end-0 p-3 z-1">
            <AddToBookmarkJob
              size="sm"
              companyDetails={companyDetails}
              jobDetails={jobDetails}
              onRemoved={() => setIsRemoved(true)}
            />
          </div>

          <Row className="g-3 align-items-center">
            {/* Company Logo */}
            <Col className="col-auto">
              <Link to={jobDetailsUrl} className="d-block">
                <div
                  className="bg-light rounded-3 p-2 d-flex align-items-center justify-content-center border"
                  style={{ width: "80px", height: "80px" }}
                >
                  <img
                    src={(() => {
                      const logoSrc = companyDetails?.logo
                        ? getCompanyLogo(companyDetails.logo)
                        : userImage6;
                      return logoSrc;
                    })()}
                    alt={companyDetails?.name || "Company Logo"}
                    className="img-fluid rounded"
                    style={{
                      maxHeight: "100%",
                      maxWidth: "100%",
                      objectFit: "contain",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = userImage6;
                    }}
                  />
                </div>
              </Link>
            </Col>

            {/* Job Information */}
            <Col>
              <div className="pe-4">
                <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
                  <h5 className="fs-17 mb-0 fw-semibold">
                    <Link
                      to={jobDetailsUrl}
                      className="text-dark text-decoration-none"
                    >
                      {jobDetails?.jobTitle}
                    </Link>
                  </h5>

                  <span className="text-muted fs-13">
                    ({getJobExperiences(jobDetails)} Exp.)
                  </span>

                  {/* Job Status Badge (Open / Closed) */}
              <div className="d-flex align-items-center gap-2">
                      {/* Already Applied Disabled Button */}
                 

                      {/* Application Status Badges */}
                      {applicationStatus === "shortlisted" && (
                        <span className="badge bg-success px-2.5 py-1.5 fs-12 fw-semibold rounded-pill">
                          Shortlisted
                        </span>
                      )}

                      {(applicationStatus === "rejected" || applicationStatus === "reject") && (
                        <span className="badge bg-danger px-2.5 py-1.5 fs-12 fw-semibold rounded-pill">
                          Rejected
                        </span>
                      )}

                      {applicationStatus === "pending" && (
                        <span className="badge bg-warning text-dark px-2.5 py-1.5 fs-12 fw-semibold rounded-pill">
                          Pending
                        </span>
                      )}
                    </div>
                </div>

                <div className="d-flex align-items-center flex-wrap gap-3 text-muted fs-14 mt-2">
                  <span className="fw-medium text-secondary">
                    <i className="uil uil-building me-1 text-primary"></i>
                    {companyDetails?.name || "Company"}
                  </span>
                  <span className="border-start ps-3">
                    <i className="mdi mdi-map-marker me-1 text-primary"></i>
                   {(() => {
  const name = bookmarkItem?.location?.name || jobDetails?.location;
  const state = bookmarkItem?.location?.state;

  if (name && state) return `${state}, ${name}`;
  if (name) return name;
  if (state) return state;
  return "India";
})()}
                  </span>
                  <span className="border-start ps-3 fw-medium text-dark">
                    {/* <i className="uil uil-wallet me-1 text-primary"></i> */}
                    {getSalaryAmount(jobDetails)}
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        {/* Card Footer */}
        <div className="card-footer bg-light-subtle border-top p-3 rounded-bottom-3">
          <Row className="g-3 align-items-center justify-content-between">
            {/* Trending Keywords */}
            <Col md={6}>
              <div className="d-flex align-items-center flex-wrap gap-2">
                <div className="d-flex align-items-center text-primary fw-medium me-1 fs-13">
                  <i className="uil uil-chart-growing me-1"></i>
                  <span>Keywords:</span>
                </div>

                <div className="d-flex flex-wrap gap-1">
                  {jobDetails?.searchKeywords ? (
                    jobDetails.searchKeywords
                      .split(",")
                      .map((keyword, index) => (
                        <span
                          key={index}
                          className="badge bg-primary-subtle text-primary border border-primary-subtle px-2.5 py-1 rounded-pill fw-normal fs-12"
                        >
                          #{keyword.trim()}
                        </span>
                      ))
                  ) : (
                    <span className="text-muted fs-13">No keywords added</span>
                  )}
                </div>
              </div>
            </Col>

            {/* Apply Action / Already Applied & Application Status */}
            <Col md={6}>
              <div className="d-flex flex-column align-items-md-end justify-content-center">
                {isAppliedJob ? (
                  <>
                    <div className="d-flex align-items-center gap-2">
                      {/* Already Applied Disabled Button */}
                      <button
                        className="btn btn-outline-success btn-sm rounded-pill px-3 py-1.5 fw-semibold fs-13 d-inline-flex align-items-center"
                        disabled
                      >
                        <i className="uil uil-check-circle me-1 fs-15"></i>
                        Already Applied
                      </button>

                 


                
                    </div>

                    {formattedAppliedDate && (
                      <span className="text-muted fs-12 mt-1">
                        <i className="uil uil-calendar-alt me-1 text-primary"></i>
                        Applied on:{" "}
                        <strong className="text-dark">
                          {formattedAppliedDate}
                        </strong>
                      </span>
                    )}
                  </>
                ) : (
                  <button
                    type="button"
                    onClick={() => openApplyJobModal(jobDetails)}
                    className="btn btn-primary btn-sm rounded-pill px-4 py-1.5 fw-semibold shadow-sm fs-13 d-inline-flex align-items-center"
                  >
                    Apply Now
                    <i className="uil uil-arrow-right ms-1 fs-15"></i>
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <ApplyJobModal
        currJob={currJob}
        setApplyJobModal={setApplyJobModal}
        applyJobModal={applyJobModal}
      />
    </>
  );
};


export default BookmarkJobItem;